import { render, staticRenderFns } from "./ApartmentUpdate.vue?vue&type=template&id=5f4e8c98"
import script from "./ApartmentUpdate.vue?vue&type=script&lang=js"
export * from "./ApartmentUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports